import { FLOW_STATES, VERIFICATION_BRANCHES } from '../../flow/mock/flowDefinition';

const TERMINAL_STATES = [
    FLOW_STATES.completed,
    FLOW_STATES.warning,
    FLOW_STATES.failed,
];

const isTerminal = (state) => TERMINAL_STATES.includes(state);

const getLiveVerificationStats = (nodes, relationships, bid) => {
    const stages = nodes.filter((node) => node.role === 'stage');
    const branches = nodes.filter((node) => node.role === 'branch');
    const analysis = nodes.find((node) => node.role === 'analysis');
    const completedStages = stages.filter((node) => isTerminal(node.state));
    const companyFields = Object.values(bid.company || {}).filter((value) => (
        value !== null && value !== undefined && value !== '' && value !== '—'
    )).length;

    return {
        agentsCompleted: branches.filter((node) => isTerminal(node.state)).length
            + (analysis && isTerminal(analysis.state) ? 1 : 0),
        agentsTotal: VERIFICATION_BRANCHES.length + 1,
        checksPerformed: completedStages.length,
        checksTotal: stages.length,
        dataPoints: companyFields + (bid.documents?.length || 0) + (completedStages.length * 2),
        crossChecks: relationships.filter((relationship) => (
            (relationship.dependencyType === 'data-dependency'
                || relationship.dependencyType === 'analysis-input')
            && isTerminal(relationship.state)
        )).length,
        findings: stages.filter((node) => (
            node.state === FLOW_STATES.warning || node.state === FLOW_STATES.failed
        )).length,
        categories: VERIFICATION_BRANCHES.length,
        completed: completedStages.length,
        inProgress: stages.filter((node) => node.state === FLOW_STATES.processing).length,
        pending: stages.filter((node) => node.state === FLOW_STATES.pending).length,
    };
};

export default getLiveVerificationStats;
